import axios from 'axios';
//import moment from 'moment';
//import _ from 'lodash';

export default {
  data() {
    return {
      _requestsCount: 0
    };
  },
  computed: {
    token() {
      return localStorage.getItem('authToken');
    }
  },
  watch: {
    '$data._requestsCount'() {
      if (this.$data._requestsCount > 0) {
        this.blockUI();
      } else {
        this.releaseUI();
      }
      if (this.$data._requestsCount < 0) {
        // truncates value at 0
        this.$data._requestsCount = 0;
      }
    }
  },
  filters: {
    count(value) {
      if (!value) {
        return 0;
      }
      return value.length;
    } /*,
    toDateStr(value) {
      const m = moment(value);
      if (m.isValid()) {
        return m.format('YYYY-MM-DD');
      }
      return 'Invalid date';
    },
    humanTimeFromNow(value) {
      return moment(value).fromNow();
    },
    fullDateString(value) {
      return moment(value).format('MMMM, D, YYYY');
    }*/
  },
  methods: {
    blockUI() {
      document.getElementsByTagName('html')[0].style.cursor = 'wait';
      document.getElementsByTagName('html')[0].style['pointer-events'] = 'none';
    },
    releaseUI() {
      document.getElementsByTagName('html')[0].style.cursor = 'auto';
      document.getElementsByTagName('html')[0].style['pointer-events'] = 'auto';
    },
    normalizeStr(value) {
      return value
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .trim();
    },
    // axiosRequest(method, url, data, headers = {}, responseType = 'json') {
    axiosRequest(
      method,
      url,
      data,
      { headers = {}, responseType = 'json', ...rest } = {}
    ) {
      if (method === undefined) {
        console.error('axiosRequest requires at least one argument');
        return null;
      }
      if (url === undefined) {
        url = method;
        method = 'GET';
      }
      method = method.toLowerCase();
      this.$data._requestsCount++;
      return axios({
        method,
        baseURL: process.env.VUE_APP_BACKEND_API,
        url: url,
        responseType,
        headers: {
          Authorization: 'Bearer ' + this.token,
          ...headers
        },
        data: data ? data : null,
        params: data && method === 'get' ? data : null,
        ...rest
      }).finally(() => this.$data._requestsCount--);
    },
    showErrorMessage(error) {
      console.log(error);
      this.$notify({
        title: '',
        message: error,
        type: 'error',
        position: 'bottom-right',
        showClose: false,
        duration: 3000
      });
      /*
      if (typeof error == 'string') {
        this.$toasted.error(error);
      } else if (
        error.response != undefined &&
        error.response.data.errors != undefined &&
        error.response.data.errors.length > 0
      )
        this.$toasted.error(error.response.data.errors[0].message);
      else if (error.response.data.message != '') {
        this.$toasted.error(error.response.data.message);
      }*/
    },
    showSuccessMessage(msg) {
      this.$notify({
        title: '',
        message: msg,
        type: 'success',
        position: 'bottom-right',
        showClose: false,
        duration: 3000
      });
    }
  }
};
